import * as PropTypes from 'prop-types';
import React from 'react';

import { BarberPoleContainer, StyledBarberPole, MessageContainer } from './styles';

const BarberPole = (props) => {
  const { message } = props;

  return (
    <BarberPoleContainer data-testid="loader">
      <StyledBarberPole />
      {message && <MessageContainer>{message}</MessageContainer>}
    </BarberPoleContainer>
  );
};

BarberPole.propTypes = {
  message: PropTypes.string,
};

export default BarberPole;
